var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhotos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_602_4448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_602_4448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E2248"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_602_4448",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_602_4448",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotos);
export default __webpack_public_path__ + "static/media/icon_photos.8dfab7fd7d086dc4443ccc96cdc96037.svg";
export { ForwardRef as ReactComponent };